<template>
    <div class="Mobiles">
        <Mobileheader name="园测文化" routeNmae="/about"  v-if="$store.state.isMobile !== 3"/>
        <div class="headers">
            <img class="banner" src="@/assets/img/classic/back.jpg" alt="" />
            <img class="Text animate__animated animate__zoomIn" src="../../assets/img/classic/title.png" alt="" />
        </div>
        <div class="topTitle">
            <div class="chinese">公司简介</div>
            <div class="english">COMPANY PROFILE</div>
        </div>
        <div class="contents introduction">
            <img src="@/assets/img/company.jpg" />
            <!-- <p> 园测信息科技股份有限公司成立于1995年，是国家高新技术企业、江苏省双软认证企业，中国地理信息产业前50强，目前位列第34位。公司具备甲级测绘资质，通过CMMI五级软件成熟度认证、ISO9001质量管理体系认证和ISO27001信息安全管理体系认证，累计获得国家和省部级以上科技进步奖40余项、专利40余项、软件产品及著作权230余项。
            </p>

            <p>公司现有员工逾1000名，其中本科以上学历占比超90%，研究生占比40%，设有城市空间智能感知与时空大数据融合创新中心、江苏省地理人工智能工程技术研究中心、苏州市测绘地理信息工程技术研究中心、苏州工业园区博士后科研工作站、武汉大学研究生工作站等。
            </p>

            <p>公司成立28年来，全程参与了苏州工业园区“一张蓝图”的绘制与实现，是园区智慧城市建设的长效驱动力，形成了以地理信息技术为核心的，从基础数据采集、大数据分析到智慧化应用的全链条、全生命周期的智慧城市解决方案，涵盖智慧交通、智慧城管、智慧规划、智慧国土、智慧乡镇等各个领域，并在江苏南京、徐州、宿迁、南通，安徽滁州，广西钦州，浙江嘉善，重庆，北京等地设立分子公司，将“园区经验”输出全国。
            </p> -->

            <p v-html="bannerListMain[0].titleMain">
                 <!-- 园测信科以智慧信息构建更美好的城市生活为使命，打造智慧开发区和新型城镇建设领先品牌。 -->
                </p>
        </div>

        <div class="contents qualifications">
            <div class="topTitle">
                <div class="chinese">公司信息</div>
                <div class="english">COMPANY INFORMATION</div>
            </div>
            <el-collapse v-model="activeName" accordion>
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="title">
                            <span>企业资质</span><span>ENTERPRISE QUALIFICATION</span>
                        </div>
                    </template>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz1.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz2.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz3.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz4.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz5.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz6.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz7.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz8.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz9.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz9_1.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz9_2.png" />
                    </div>

                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz10.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz11.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz12.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zz/zz13.png" />
                    </div>
                  
                </el-collapse-item>
                <!-- <el-collapse-item name="2">
                    <template slot="title">
                        <div class="title">
                            <span>科研实力</span><span>SCIENTIFIC RESEARCH STRENGTH</span>
                        </div>
                    </template>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zhengshu/ky1.jpg" />
                    </div>

                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/zhengshu/ky2.jpg" />
                    </div>
                </el-collapse-item> -->

                <el-collapse-item name="3">
                    <template slot="title">
                        <div class="title">
                            <span>荣誉奖项</span><span>HONORARY AWRRDS</span>
                        </div>
                    </template>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs1.png" />
                    </div>

                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs2.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs3.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs4.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs5.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs6.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs7.png" />
                    </div>

                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs8.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/zs9.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/jx1.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/jx2.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/jx3.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/jx4.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="@/assets/img/classic/ry/jx5.png" />
                    </div>
                </el-collapse-item>
                <el-collapse-item name="4">
                    <template slot="title">
                        <div class="title">
                            <span>企业内刊</span><span>ENTERPRISE INTERNAL JOURNAL</span>
                        </div>
                    </template>
                    <div class="sslideDiv">
                        <img src="swip/1.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="swip/2.png" />
                    </div>
                    <div class="sslideDiv">
                        <img src="swip/3.png" />
                    </div>
                </el-collapse-item>
            </el-collapse>



        </div>
        <div class="example">
            <div class="topTitle">
                <div class="chinese">使命愿景</div>
                <div class="english">COMPANY INFORMATION</div>
            </div>
            <div class="exampleItem">
                <img src="@/assets/img/classic/culture_item.png" />
                <h2>使命</h2>
                <p>以智慧信息构建更美好的城市生活</p>
            </div>
            <div class="exampleItem">
                <img src="@/assets/img/classic/culture_item2.png" />
                <h2>愿景</h2>
                <p>智慧城市整体解决方案提供商</p>
                <p>智慧开发区和新型城镇建设领先品牌</p>
            </div>
            <div class="exampleItem">
                <img src="@/assets/img/classic/culture_item3.png" />
                <h2>核心价值观</h2>
                <p>客户至上 贡献为荣 求真务实 合作共赢</p>
            </div>
        </div>
        <div class="partyMember">
            <div class="topTitle">
                <div class="chinese">十要十禁</div>
                <div class="english">TEN POINTS TEN PROSCRIPTIONS</div>
            </div>
            <div class="list">
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">
                    <span>01</span>
                    <p>要共启愿景，禁舍本逐末。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">
                    <span>02</span>
                    <p>要客户导向，禁被动应付。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">
                    <span>03</span>
                    <p>要清廉正直，禁自私自利。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">
                    <span>04</span>
                    <p>要勇于担责，禁推诿扯皮。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">
                    <span>05</span>
                    <p>要求真务实，禁弄虚作假。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">

                    <span>06</span>
                    <p>要体系闭环，禁有始无终。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">

                    <span>07</span>
                    <p> 要追求卓越，禁安于现状。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">

                    <span>08</span>
                    <p>要开拓创新，禁因循守旧。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">

                    <span>09</span>
                    <p>要高效执行，禁敷衍拖拉。</p>
                </div>
                <div class="itemTen">
                    <img src="@/assets/img/classic/ten10_base.png" alt="">

                    <span>10</span>
                    <p>要顾全大局，禁各行其是。</p>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
// import {
// 	getProductProgrammeList
// } from "@/api/web.js"
import { getProductProgrammeList } from "@/api/solutio";
import MobileSwiper from "@/components/mobileSwiper"
import FlexTop from "@/components/flexTop"
import { banner } from "@/api/public"
export default {
    components: {
        MobileSwiper,
        FlexTop
    },
    data() {
        return {
            bannerListMain:[],
            activeNames: ['1'],
            tabIndex: '0',
            tabList: ['企业资质', '科研实力', '荣誉奖项', '企业内刊']

        };
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
            banner({ isRelease: this.$store.state.editStatus, type: 5 }).then(res => {
            this.bannerListMain = res.data;
            if (this.bannerListMain.length > 0) {
              // this.bannerListMain[0].titleMain = this.bannerListMain[0].titleMain.replace(/^<p>(.*)<\/p>$/, "$1")
              this.$forceUpdate()
            }
            if (this.bannerListMain.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerListMain[0].imgUrl})`;
            }
          })
        },
        handleClick(e) {

        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:767px) {

    .headers {
    position: relative;

    .banner {
        width: 100%;
    }

    .Text {
        width: 400px;
        position: absolute;
        top: 130px;
        left: 50%;
        margin-left: -200px;
    }
}

.topTitle {
    color: #1461fe;
    padding: 20px;
    text-align: center !important;
    .chinese {
        font-size: 34px;
    }

    .english {
        font-size: 24px;
        margin-top: 10px;
    }
}

.contents {
    padding: 0 30px;
}

.introduction {
    font-size: 28px;

    img {
        width: 100%;
    }

    p {
        text-indent: 2em;
        font-size: 28px;
        margin-top: 10px;
    }
}


.qualifications {
    background-color: #fff;
    margin-top: 60px;

    .sslideDiv {
        img {
            width: 100%;
        }
    }

    ::v-deep {
        .el-collapse-item__header {
            height: 80px !important;
        }
    }

    .title {
        span {
            font-size: 28px;

            &:first-child {
                color: #333;
                font-weight: bold;
            }

            &:last-child {
                margin-left: 20px;
                color: #333;
                font-size: 24px;
            }
        }
    }
}

.example {
    margin-top: 60px;
    padding: 0 30px;

    .exampleItem {
        margin-bottom: 30px;

        img {
            width: 100%;
        }

        h2 {
            font-size: 30px;
            margin-bottom: 10px;
            text-align: center !important;
        }

        p {
            font-size: 28px;
            text-align: center !important;
        }
    }
}

.partyMember {
    margin-top: 60px;
    padding: 0 30px;

    .list {
        .itemTen {
            position: relative;
            width: 100%;
            line-height: 80px;
            margin-bottom: 22px;
            display: flex;
            justify-content: space-between;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }

            text-align: left;

            span,
            p {
                position: relative;
                z-index: 9;
                font-size: 28px;
                text-align: left;

            }

            span {
                color: #fff;
                font-size: 40px;
                padding-left: 40px;
            }

            p {
                margin-right: 160px;
            }

        }
    }
}
}
</style>